import { Paper as MuiPaper, PaperProps as MuiPaperProps, useMediaQuery } from "@mui/material";
import { forwardRef } from "react";
import { useTheme } from "../../hooks";

type PaperProps = MuiPaperProps & {};

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ sx, children, ...rest }, ref) => {
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <MuiPaper ref={ref} sx={{ borderRadius: upSm ? "10px" : "0", ...sx }} {...rest}>
      {children}
    </MuiPaper>
  );
});
